<template>
  <div class="flex gap-x-1">
    <template v-if="callIds.length > 1">
      <wui-dropdown
        direction="left-top"
        class="px-2"
        close-on-click-outside
        close-on-click-inside
        plain
      >
        <template #activator="{ toggle }">
          <wui-btn
            data-test="waiting-approve-button-approve-btn"
            icon
            prepend-icon="taskAlt"
            @click="toggle"
          />
        </template>
        <template #default>
          <wui-card
            state="text"
            shadow="overflow"
          >
            <wui-list>
              <wui-list-item
                v-for="(id, i) in callIds"
                :key="id"
                icon="taskAlt"
                @click="approve(id)"
              >
                {{ t('common.connectConnection', { number: `№${i + 1}` }) }}
              </wui-list-item>
            </wui-list>
          </wui-card>
        </template>
      </wui-dropdown>
    </template>
    <template v-else>
      <wui-btn
        data-test="waiting-approve-button-approve-btn"
        icon
        prepend-icon="taskAlt"
        auto-loading
        @click.stop="approve(callIds.at(0))"
      />
    </template>
    <wui-btn
      icon
      prepend-icon="closeRegularMdM"
      variant="neut"
      state="alpha"
      data-test="waiting-approve-cancel-btn"
      @click.stop="emit('cancel')"
    />
  </div>
</template>

<script setup lang="ts">
import { useRenderNotifier, WuiBtn, WuiCard, WuiDropdown, WuiList, WuiListItem } from '@wui/common-library'

import { useLocalization } from '@/shared/composables/localization'
import { useRoomControl } from '@/shared/composables/use-room-control'
import { PSTNGUEST } from '@/shared/utils/constants'
import { getPServedFromString } from '@/shared/utils/uri'

const props = defineProps<{
  pServedRoom: string
  contactId: string,
  callIds: string[]
}>()

const emit = defineEmits<{
  (event: 'cancel'): void
}>()

const { acceptIncomingCall } = useRoomControl()
const { notifyError } = useRenderNotifier()
const { t } = useLocalization()

const approve = async (callId?: string) => {
  try {
    await acceptIncomingCall(props.pServedRoom, getPServedFromString(`${PSTNGUEST}-${props.contactId}`), callId)
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    notifyError(errorMessage)
  } finally {
    emit('cancel')
  }
}
</script>
